import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import * as analytics from "../../analytics";
import { OrderPromo } from "../../components/organisms";
import { IPromotion } from "../../services/api/promotion";
import {
  getCreditBalance,
  promocodeValidation,
} from "../../store/checkout/actions";
import { IRootState } from "../../store/index";
import { normalizeObjects } from "../../store/utils";
import { mapArrayCounter } from "../../utils/index";

interface IReduxProps {
  creditBalance?: number;
  isLogedIn: boolean;
  promocode?: IPromotion;
  promocodeError?: string;
  treatments: string[];
}

interface IState {
  promoCode: string;
}

type Props = IReduxProps & { dispatch: Dispatch<any> };

class PromocodeContainer extends React.Component<Props, IState> {
  public componentDidMount() {
    if (this.props.isLogedIn && this.props.creditBalance === undefined) {
      this.props.dispatch(getCreditBalance() as any);
    }
  }

  public state = {
    promoCode: "",
  };

  public setPromocode = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({ promoCode: e.currentTarget.value });
  };

  public submitPromocode = (): void => {
    if (this.state.promoCode && this.state.promoCode.length > 0) {
      this.props.dispatch(
        promocodeValidation(
          this.state.promoCode,
          mapArrayCounter(this.props.treatments, "count", "urn"),
        ) as any,
      );
      this.setState({ promoCode: "" });

      analytics.track({
        name: analytics.AnalyticsEvents.PROMO_CODE_SET,
        payload: {
          code: this.state.promoCode,
        },
      });
    }
  };

  public render() {
    return (
      <OrderPromo
        codeValue={this.state.promoCode}
        isLoggedIn={this.props.isLogedIn}
        isButtonDisabled={!Boolean(this.state.promoCode)}
        onInputChange={this.setPromocode}
        onSubmit={this.submitPromocode}
        promocodeError={this.props.promocodeError}
      />
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    creditBalance: state.checkoutState.creditBalance,
    isLogedIn: state.userState.isLogedIn,
    promocode: state.checkoutState.promocode,
    promocodeError: state.checkoutState.promocodeError,
    treatments: normalizeObjects(state.treatmentsState.treatments),
  };
};

const store =
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(PromocodeContainer);

export { store as PromocodeContainer };
